import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { ItemPickerGrid } from './grid';
const b = bemClassBuilder('v-item-picker-list');
export const ItemPickerList = ({ itemProfilePages }) => {
    const i18n = useI18n();
    return (_jsx("ul", Object.assign({ className: b.block() }, { children: itemProfilePages.map(page => {
            return (_jsxs("li", Object.assign({ className: b.element('item') }, { children: [_jsx("h2", Object.assign({ className: b.element('heading') }, { children: i18n.translatable(page.title) })), _jsx(ItemPickerGrid, { itemButtons: page.buttons })] }), page.number));
        }) })));
};
ItemPickerList.displayName = 'ItemPickerList';
